import styled from '@emotion/styled/macro';

export const StyledPageWrapper = styled.div`
  margin-top: 95px;
`;

export const StyledPageContainer = styled.div`
  max-width: 1080px;
  width: 100%;
  padding: 0 32px;
  margin: 0 auto;
`;

export const StyledPageContent = styled.div`
  margin: 60px 0;
`;

export const H2 = styled.h2`
  font-size: 28px;
  margin-bottom: 30px;
  margin: 0;
  line-height: 1;
  font-weight: bold;
`;

export const H4 = styled.h2`
  text-transform: uppercase;
  font-size: 20px;
  margin: 0;
  line-height: 1;
`;

export const H5 = styled.h2`
  font-size: 20px;
  font-weight: normal;
  line-height: 1.5;
  margin-bottom: 0;
`;
